import React from 'react';
import { FormControlLabel, Grid, Radio, RadioGroup } from '@mui/material';

import { Icon, ModuleSearchField, SearchSelectField, SimpleTextField, useSettings } from 'app/main/components';
import { DetailsSectionWrapper, type DetailsSectionInfoContentProps } from 'app/main/components/page-layouts';

export default function UsersDetailsSectionLoginSettings(props: Omit<DetailsSectionInfoContentProps, 'logProps'>) {
	const { t } = useSettings();

	const [mode, setMode] = React.useState('new');

	const handleModeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setMode(event.target.value);
		props.sendChange('user_mail', null);
		props.sendChange('user_pass', null);
		props.sendChange('user_confirm_pass', null);
		props.sendChange('user_role', null);
	};

	return (
		<DetailsSectionWrapper
			avatar={<Icon icon="text-subject" />}
			title={t('USERS_SYSTEM_USER_CREATION_SECTION')}
			subheader={t('USERS_SYSTEM_USER_CREATION_SUBHEADER')}
		>
			<RadioGroup name="mode" value={mode} onChange={handleModeChange}>
				<FormControlLabel
					value="new"
					control={<Radio color="primary" />}
					label={t('DETAILS_USERS_SECTION_ADD_NEW')}
				/>
				<Grid container spacing={1} className="py-8 pl-24">
					<Grid size={12}>
						{/* MAIL */}
						<SimpleTextField
							name="user_mail"
							label={t('DETAILS_USERS_FIELD_MAIL')}
							type="email"
							value={props.model.user_mail}
							isEdit={mode === 'new'}
							sendChange={props.sendChange}
							required={mode === 'new'}
							validationError={t('ERROR_TEXT_REQUIRED')}
						/>
					</Grid>
					<Grid size={12}>
						{/* PASSWORD */}
						<SimpleTextField
							name="user_pass"
							label={t('DETAILS_USERS_FIELD_PASSWORD')}
							type="password"
							value={props.model.user_pass}
							isEdit={mode === 'new'}
							sendChange={props.sendChange}
							required={mode === 'new'}
							validationError={t('ERROR_TEXT_REQUIRED')}
						/>
					</Grid>
					<Grid size={12}>
						{/* CONFIRM PASSWORD */}
						<SimpleTextField
							name="user_confirm_pass"
							label={t('DETAILS_USERS_FIELD_CONFIRM_PASSWORD')}
							type="password"
							value={props.model.user_confirm_pass}
							isEdit={mode === 'new'}
							sendChange={props.sendChange}
							required={mode === 'new'}
							validations={{ equalsField: mode === 'new' ? 'user_pass' : undefined }}
							validationErrors={{
								isDefaultRequiredValue: t('ERROR_TEXT_REQUIRED'),
								equalsField: t('ERROR_PASSWORD_NO_MATCH')
							}}
						/>
					</Grid>
					<Grid size={12}>
						{/* ROLE */}
						<SearchSelectField
							name="user_role"
							label={t('DETAILS_USERS_FIELD_ROLE')}
							systable="sys_roles"
							value={props.model.user_role}
							sendChange={props.sendChange}
							isEdit={mode === 'new'}
							required={mode === 'new'}
							validationError={t('ERROR_TEXT_REQUIRED')}
						/>
					</Grid>
				</Grid>
				<FormControlLabel
					value="existing"
					control={<Radio color="primary" />}
					label={t('DETAILS_USERS_SECTION_USE_EXISTING')}
				/>
				<Grid container spacing={1} className="py-8 pl-32">
					<Grid size={12}>
						{/* SYS USER */}
						<ModuleSearchField
							name="user_uid"
							label={t('DETAILS_USERS_FIELD_MAIL')}
							module="sys_users"
							uid={props.model.user_uid}
							isEdit={mode === 'existing'}
							sendChange={props.sendChange}
							required={mode === 'existing'}
							validationError={t('ERROR_TEXT_REQUIRED')}
						/>
					</Grid>
					<Grid size={12}>
						{/* ROLE */}
						<SearchSelectField
							name="user_role"
							label={t('DETAILS_USERS_FIELD_ROLE')}
							systable="sys_roles"
							value={props.model.user_role}
							sendChange={props.sendChange}
							isEdit={mode === 'existing'}
							required={mode === 'existing'}
							validationError={t('ERROR_TEXT_REQUIRED')}
						/>
					</Grid>
				</Grid>
			</RadioGroup>
		</DetailsSectionWrapper>
	);
}
